
import Config from './config';

type Config = {
    AUTH_PUBLIC_TOKEN: string
    FIREBASE_APIKEY: string
    FIREBASE_AUTHDOMAIN: string
    FIREBASE_PROJECTID: string
    FIREBASE_STORAGEBUCKET: string
    FIREBASE_MESSAGINGSENDERID: string
    FIREBASE_APPID: string
    FIREBASE_MEASUREMENTID: string
    IS_FIREBASE_EMULATED: string

    SESSION_DURATION_MINUTES: string
    SESSION_BUFFER_MINUTES: string
    SESSION_MAX_DURATION_MINUTES: string
    SESSION_ACTIVITY_TIMEOUT_MINUTES: string

    POSTHOG_PUBLIC_KEY: string
    POSTHOG_HOST: string

    SIMILARITY_THRESHOLD: string

    APP_VERSION: string
}

declare global {
    interface Window {
        audiolo: Config
    }
}


export default {
    authPublicToken: window.audiolo.AUTH_PUBLIC_TOKEN,
    firebaseApiKey: window.audiolo.FIREBASE_APIKEY,
    firebaseAuthDomain: window.audiolo.FIREBASE_AUTHDOMAIN,
    firebaseProjectId: window.audiolo.FIREBASE_PROJECTID,
    firebaseStorageBucket: window.audiolo.FIREBASE_STORAGEBUCKET,
    firebaseMessagingSenderId: window.audiolo.FIREBASE_MESSAGINGSENDERID,
    firebaseAppId: window.audiolo.FIREBASE_APPID,
    firebaseMeasurementId: window.audiolo.FIREBASE_MEASUREMENTID,
    isFirebaseEmulated: window.audiolo.IS_FIREBASE_EMULATED,

    sessionDurationMinutes: window.audiolo.SESSION_DURATION_MINUTES,
    sessionBufferMinutes: window.audiolo.SESSION_BUFFER_MINUTES,
    sessionMaxDurationMinutes: window.audiolo.SESSION_MAX_DURATION_MINUTES,
    sessionActivityTimeoutMinutes: window.audiolo.SESSION_ACTIVITY_TIMEOUT_MINUTES,

    posthogPublicKey: window.audiolo.POSTHOG_PUBLIC_KEY,
    posthogHost: window.audiolo.POSTHOG_HOST,

    similarityThreshold: window.audiolo.SIMILARITY_THRESHOLD,

    appVersion: window.audiolo.APP_VERSION,
}